<template>
  <div class="content-profile">
    <el-main>
      <el-card class="content-info-card">
        <div v-if="loading" class="loading-container">
          <el-skeleton animated>
            <!-- ... existing code ... -->
          </el-skeleton>
        </div>

        <div v-else-if="errorMessage" class="error-container">
          <div class="error-icon">
            <i class="el-icon-warning"></i>
          </div>
          <h3 class="error-title">Unable to Load Content</h3>
          <p class="error-message">{{ errorMessage }}</p>
          <el-button type="primary" @click="$router.back()">Go Back</el-button>
        </div>

        <div v-else class="content-container">
          <div class="content-header">
            <div class="cover-image">
              <img
                v-if="contentInfo.cover_url"
                :src="contentInfo.cover_url"
                alt="Content Cover"
              />
              <div v-else class="placeholder-cover">
                <i class="el-icon-picture-outline"></i>
              </div>
            </div>

            <div class="header-content">
              <div class="info-header">
                <div class="content-meta">
                  <div class="content-type-tag" :class="content_type">
                    {{ this.content_type === 'collection' ? 'Deck' : this.content_type }}
                  </div>

                </div>
                <h2 class="content-title">{{ contentInfo.title }}</h2>
                <p class="content-description">{{ contentInfo.description }}</p>

              </div>
              <div class="action-buttons">
                <div class="price-tag" >
                    <i class="el-icon-price-tag"></i>
                    <template v-if="hasCustomPrice">
                      <span class="original-price">${{ contentInfo.usd_price }}</span>
                      <span>{{ displayPrice === 0 ? 'FREE' : '$' + displayPrice }}</span>
                      <span class="discount-badge">{{ discountPercentage }}% OFF</span>
                    </template>
                    <template v-else>
                      <span>{{ contentInfo.usd_price === 0 ? 'FREE' : '$' + contentInfo.usd_price }}</span>
                    </template>
                  </div>
                
                <div class="action-buttons-right">
                  <el-button
                  type="primary"
                  @click="readContent"
                  class="read-button"
                >Read</el-button>
                  
                  <el-button 
                    v-if="userType === 'advisor'"
                    type="primary" 
                    @click="shareToStudents"
                  >
                    Share to My Students
                    <el-tooltip content="Share free access link with your students" placement="top">
                      <i class="el-icon-info" style="margin-left: 5px"></i>
                    </el-tooltip>
                  </el-button>  
                  <el-button 
                    v-if="userType === 'advisor'"
                    type="primary" 
                    @click="getCopiesForStudents"
                  >
                    Get Copies for My Students
                    <el-tooltip content="Purchase multiple copies for your students" placement="top">
                      <i class="el-icon-info" style="margin-left: 5px"></i>
                    </el-tooltip>
                  </el-button>
                  
                  <el-button 
                    v-if="userType === 'advisor'"
                    type="primary"
                    plain
                    @click="viewOrders"
                  >
                    View Orders
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <div class="content-stats">
            <div class="stats-left">
              <div class="stat-item">
                <i class="el-icon-folder"></i>
                <span>{{ contentInfo.group_count || 0 }} Groups</span>
              </div>
              <div class="stat-item">
                <i class="el-icon-document"></i>
                <span>{{ contentInfo.knowit_count || 0 }} Stacks</span>
              </div>
              <div class="stat-item">
                <i class="el-icon-reading"></i>
                <span>{{ contentInfo.content_count || 0 }} Cards</span>
              </div>
              <div class="stat-item">
                <i class="el-icon-question"></i>
                <span>{{ contentInfo.quiz_count || 0 }} Quizzes</span>
              </div>
            </div>
            <div class="stats-right">

            </div>
          </div>

          

          

          <div class="groups-container" v-if="contentInfo.groups">
            <div class="groups-grid">
              <div
                v-for="(group, groupIndex) in contentInfo.groups"
                :key="groupIndex"
                class="group-section"
              >
                <div class="group-header">
                  <h3>{{ groupIndex + 1 }}. {{ group.title }}</h3>
                </div>
                <div class="group-items-count">
                  {{ (group.knowits || []).length }}
                  {{ (group.knowits || []).length === 1 ? "Stack" : "Stacks" }}
                </div>
              </div>
            </div>
            <div v-if="!contentInfo.groups.length" class="no-data">
              <i class="el-icon-document"></i>
              <p>No groups in this content yet</p>
            </div>
          </div>
            <!-- <div class="copies-purchased" >
              <div class="copies-info">
                <i class="el-icon-shopping-cart-2"></i>
                <span>{{ copies_purchased.length }} Copies Distributed</span>
              </div>
            </div> -->
          
          <el-dialog
            title="Share to My Students"
            :visible.sync="shareDialogVisible"
            width="500px"
            class="share-dialog"
          >
            <div class="share-content">
              <div class="share-notes">
                <p><i class="el-icon-info"></i> Students can access this content for free using this link.</p>
                <p><i class="el-icon-warning"></i> Only students with valid accounts can access the content.</p>
              </div>
              <div class="share-link-container">
                <el-input
                  v-model="shareLink"
                  placeholder="Share link"
                  :disabled="true"
                >
                  <el-button
                    slot="append"
                    @click="copyShareLink"
                    type="primary"
                  >
                    Copy
                  </el-button>
                </el-input>
              </div>
            </div>
          </el-dialog>
        </div>
        
      </el-card>
    </el-main>
  </div>
</template>

<script>
import { getStoreContent, postRequest } from '@/api/eclub'
import { getUserId, getUserType,getUserEmail } from '@/utils/store'
import { get } from 'sortablejs';

export default {
  name: 'ContentProfile',
  data() {
    return {
      contentInfo: {},
      loading: true,
      copies_purchased: [],
      content_type: '',
      shareDialogVisible: false,
      shareLink: '',
      userType: '',
      errorMessage: '',
    }
  },
  computed: {
    clubAvatarStyle() {
      return {
        backgroundColor: '#e6e6e6',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#666'
      }
    },
    hasCustomPrice() {
      return this.contentInfo.custom_price !== undefined
        && this.contentInfo.custom_price !== null
        && Number(this.contentInfo.custom_price) < Number(this.contentInfo.usd_price);
    },
    displayPrice() {
      if (this.hasCustomPrice) {
        return Number(this.contentInfo.custom_price);
      }
      return this.contentInfo.usd_price;
    },
    discountPercentage() {
      if (!this.hasCustomPrice) return 0;
      const original = Number(this.contentInfo.usd_price);
      const custom = Number(this.contentInfo.custom_price);
      if (original === 0) return 0;
      return Math.round(((original - custom) / original) * 100);
    }
  },
  created() {
    this.fetchContentInfo()
    this.userType = getUserType()
  },
  methods: {
    async fetchContentInfo() {
      try {
        const content_id = this.$route.query.content_id
        this.content_type = this.$route.query.content_type
        if (!content_id) {
          this.errorMessage = 'Content ID is missing'
          this.loading = false
          return
        }

        this.loading = true
        this.errorMessage = ''
        const response = await getStoreContent(content_id)

        if (response.data.code === 0) {
          this.contentInfo = response.data.data
          console.log(this.contentInfo.usd_price)
        } else {
          // Handle different error codes
          const errorMessages = {
            '-2': 'This content is not public',
            '-1': 'Content not found',
          }
          this.errorMessage = errorMessages[response.data.code] || response.data.message || 'Failed to load content'
        }
      } catch (error) {
        console.error('Error fetching content:', error)
        this.errorMessage = 'An error occurred while loading the content. Please try again later.'
      } finally {
        this.loading = false
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      return new Date(timestamp).toLocaleDateString()
    },
    formatLabel(key) {
      return key.split('_').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ')
    },
    goToClub() {
      if (this.contentInfo.club?._id) {
        this.$router.push({
          name: 'Club Profile',
          query: {
            club_id: this.contentInfo.club._id.$id
          }
        })
      }
    },
    downloadFile(file) {
      // Implement file download functionality
      window.open(file.url, '_blank')
    },
    async generateAuthCode(uniqueKey) {
      try {
        const response = await postRequest('generateAuthCode', {
          unique_key: uniqueKey,
        });
        
        if (response.data.code === 0) {
          return response.data.data;
        } else {
          throw new Error(response.data.message || 'Failed to generate auth code');
        }
      } catch (error) {
        console.error('Error generating auth code:', error);
        this.$message.error('Failed to generate authentication code');
        throw error;
      }
    },
    async readContent() {
      try {
        const uniqueKey = JSON.stringify({
          user_id: getUserId(),
          user_email: getUserEmail()
        });
        if (!uniqueKey) {
          this.$message.error('User not authenticated');
          return;
        }
        const authCode = await this.generateAuthCode(uniqueKey);
        console.log('Generated Auth Code:', authCode);
        const collectionId = this.$route.query.content_id;
        window.open(`https://learning.knowit.today/#/read-collection?collection_id=${collectionId}&auth=${authCode}`, '_blank');
      } catch (error) {
        console.error('Error reading content:', error);
        this.$message.error('Failed to read content');
      }
    },
    getCopiesForStudents() {
      this.$router.push({
        name: 'Content Order Form',
        query: {
          content_id: this.$route.query.content_id,
          title: this.contentInfo.title,
          type: this.content_type,
          cover_url: this.contentInfo.cover_url,
          usd_price: this.displayPrice,
        }
      })
    },
    shareToStudents() {
      this.shareLink = `${window.location.origin}/#/content?id=${this.$route.query.content_id}&type=${this.content_type}`;
      this.shareDialogVisible = true;
    },
    copyShareLink() {
      navigator.clipboard.writeText(this.shareLink)
        .then(() => {
          this.$message({
            message: 'Link copied to clipboard!',
            type: 'success'
          });
        })
        .catch(() => {
          this.$message.error('Failed to copy link');
        });
    },
    viewOrders() {
      this.$router.push({
        name: 'Content Orders',
        query: {
          content_id: this.$route.query.content_id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-profile {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 90px);

  .content-info-card {
    .error-container {
      text-align: center;
      padding: 60px 20px;

      .error-icon {
        font-size: 72px;
        color: #E6A23C;
        margin-bottom: 24px;

        i {
          font-size: 72px;
        }
      }

      .error-title {
        font-size: 24px;
        color: #303133;
        margin: 0 0 16px;
      }

      .error-message {
        font-size: 16px;
        color: #606266;
        margin: 0 0 32px;
      }
    }

    .content-container {
      width: 100%;

      .content-header {
        display: flex;
        gap: 24px;
        margin-bottom: 24px;

        .cover-image {
          width: 200px;
          height: 283px;
          background: #f5f7fa;
          border-radius: 8px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .placeholder-cover {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #909399;
            font-size: 48px;
          }
        }

        .header-content {
          flex: 1;

          .info-header {
            position: relative;

            .content-meta {
              display: flex;
              align-items: center;
              gap: 16px;
              margin-bottom: 16px;

              .content-type-tag {
                padding: 4px 4px;
                border-radius: 4px;
                font-size: 14px;
                text-transform: capitalize;

                &.events {
                  background-color: #e1f3d8;
                  color: #67c23a;
                }

                &.posts {
                  background-color: #fdf6ec;
                  color: #e6a23c;
                }

                &.achievements {
                  background-color: #f0f9eb;
                  color: #67c23a;
                }
              }

              .content-date {
                color: #909399;
              }

              .price-tag {
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                gap: 4px;
                padding: 4px 8px;
                background-color: #ecf5ff;
                color: #409EFF;
                border-radius: 4px;
                font-size: 14px;

                i {
                  font-size: 14px;
                }

                .original-price {
                  text-decoration: line-through;
                  color: #909399;
                  font-size: 12px;
                }

                .discount-badge {
                  background: #f56c6c;
                  color: white;
                  padding: 1px 6px;
                  border-radius: 3px;
                  font-size: 12px;
                  font-weight: 500;
                }
              }
            }

            .content-title {
              font-size: 24px;
              margin: 0 0 16px;
              color: #303133;
            }

            .content-description {
              font-size: 16px;
              line-height: 1.6;
              color: #606266;
              margin: 16px 0;
            }

            .creator-info {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-top: 12px;

              .creator-by {
                font-size: 14px;
                color: #909399;
              }

              .creator-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #dcdfe6;
              }

              .creator-name {
                font-size: 14px;
                color: #606266;
                font-weight: 500;
              }
            }
          }
        }
      }

      .content-stats {
        display: flex;
        justify-content: space-between;
        padding: 16px 0;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 24px;

        .stats-left,
        .stats-right {
          display: flex;
          gap: 24px;
        }

        .stat-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #606266;

          i {
            font-size: 18px;
          }
        }
      }

      .copies-purchased {
        background-color: #f8f9fa;
        padding: 16px 24px;
        border-radius: 8px;
        border: 1px solid #e4e7ed;
        margin: 24px 0;

        .copies-info {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #606266;

          i {
            font-size: 20px;
            color: #409EFF;
          }

          span {
            font-size: 15px;
            font-weight: 500;
          }
        }
      }

      .content-body {
        .content-details {
          margin-bottom: 24px;

          .detail-item {
            display: flex;
            margin-bottom: 12px;

            .detail-label {
              width: 140px;
              color: #909399;
              font-weight: 500;
            }

            .detail-value {
              flex: 1;
              color: #303133;
            }
          }
        }

        .content-attachments {
          h3 {
            margin-bottom: 16px;
            color: #303133;
          }

          .attachment-list {
            .attachment-item {
              display: flex;
              align-items: center;
              padding: 8px 0;
              border-bottom: 1px solid #ebeef5;

              i {
                color: #909399;
                margin-right: 8px;
              }

              .file-name {
                flex: 1;
                color: #606266;
              }
            }
          }
        }
      }

      .groups-container {
        margin-top: 24px;

        .groups-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 16px;
        }

        .group-section {
          padding: 16px;
          background: #f5f7fa;
          border-radius: 8px;

          .group-header {
            h3 {
              margin: 0;
              font-size: 16px;
              color: #303133;
            }
          }

          .group-items-count {
            margin-top: 8px;
            color: #909399;
            font-size: 14px;
          }
        }

        .no-data {
          text-align: center;
          padding: 40px;
          color: #909399;

          i {
            font-size: 48px;
            margin-bottom: 16px;
          }

          p {
            margin: 0;
          }
        }
      }

      .action-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .read-button {
          color: white !important;
        }

        .action-buttons-right {
          display: flex;
          align-items: center;
          gap: 16px;

          .price-tag {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 4px 8px;
            background-color: #ecf5ff;
            color: #409EFF;
            border-radius: 4px;
            font-size: 14px;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.share-dialog {
  .share-content {
    .share-notes {
      margin-bottom: 20px;
      
      p {
        margin: 8px 0;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #606266;
        
        i {
          color: #409EFF;
        }
      }
    }
    
    .share-link-container {
      margin-top: 16px;
    }
  }
}
</style> 